<template>
    <b-col cols="12" class="filter-form mt-2">
        <b-card>
            <b-card-body>
                <b-card-title class="h6 p-1 text-center text-white">{{ $translate('filter') }}</b-card-title>
                <form class="form-sample filter-inner mb-4 p-4">
                    <b-row>
                        <b-col md="3" cols="12" class="mt-3 mt-md-0 dd">
                            <label class="mb-2"><strong> {{ $translate('activity_types') }}</strong></label>
                            <b-form-select class="form-control" v-model="orderFilter.type" value-field="id"
                                text-field="name" :options="orderTypes" value="">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('any_type') }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="3" cols="12" class="mt-3 mt-md-0 dd officer-box">
                            <label class="mb-2"><strong> {{ $translate('officer') }}</strong></label>
                            <b-form-select class="form-control" id="input-officer" value-field="id" text-field="name"
                                v-model="orderFilter.driver_id" :options="officers" :disabled="!allowToSeeOtherOfficers">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('any_officer')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="3" cols="12" class="mt-3 mt-md-0 dd">
                            <label class="mb-2"><strong> {{ $translate('activity_status') }}</strong></label>
                            <b-form-select class="form-control" id="input-status" v-model="orderFilter.status"
                                value-field="id" text-field="name" :options="status">
                                <template #first>
                                    <b-form-select-option :value="null">
                                        {{ $translate('select_status') }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="3" cols="12" class="mt-3 mt-md-0 dd">
                            <label class="mb-2"><strong> {{ $translate('category') }}</strong></label>
                            <b-form-select class="form-control" id="input-activity-category"
                                v-model="orderFilter.request_category_id" value-field="id" text-field="name"
                                :options="categories" :disabled="false">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_activity_category')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="3" cols="12" class="mt-3">
                            <label class="mb-2"><strong> {{ $translate('due_from') }}</strong></label>
                            <div class="filter-date">
                                <input type="date" class="form-control" id="input-due_from" :max="orderFilter.due_to"
                                    v-model="orderFilter.due_from" />
                            </div>
                        </b-col>
                        <b-col md="3" cols="12" class="mt-3">
                            <label class="mb-2"><strong> {{ $translate('due_to') }}</strong></label>
                            <div class="filter-date">
                                <input type="date" class="form-control" id="input-due_to" :min="orderFilter.due_from"
                                    v-model="orderFilter.due_to" />
                            </div>
                        </b-col>
                        <b-col md="3" cols="12" class="mt-3">
                            <label class="mb-2"><strong> {{ $translate('complete_from') }} </strong></label>
                            <div class="filter-date">
                                <input type="date" class="form-control" :max="orderFilter.completion_date_to"
                                    id="input-completion-date_from" v-model="orderFilter.completion_date_from" />
                            </div>
                        </b-col>
                        <b-col md="3" cols="12" class="mt-3">
                            <label class="mb-2"><strong> {{ $translate('complete_to') }}</strong></label>
                            <div class="filter-date">
                                <input type="date" class="form-control" :min="orderFilter.completion_date_from"
                                    id="completion-date_to" v-model="orderFilter.completion_date_to" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="3" cols="12" class="mt-3 dd">
                            <label class="mb-2"><strong> {{ $translate('role') }}</strong></label>
                            <b-form-select class="form-control" id="input-role_id" v-model="orderFilter.role_id"
                                :options="roles" text-field="name" value-field="id" required trim>
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_role')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="3" cols="12" class="mt-3 dd">
                            <label class="mb-2"><strong> {{ $translate('progress_status') }}</strong></label>
                            <b-form-select class="form-control" id="input-progress-status"
                                v-model="orderFilter.progress_status_value" :options="progressStatuses" text-field="name"
                                value-field="id" required trim>
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_progress_status')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="3" cols="12" class="dd mt-3">
                            <label class="mb-2"><strong> {{ $translate('customer_agent') }}</strong></label>
                            <b-form-select class="form-control" id="input-customer-agent"
                                v-model="orderFilter.customer_agent_id" :options="customerAgents" text-field="agent_name"
                                value-field="id" required trim>
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_customer_agent')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="3" cols="12" class="dd mt-3">
                            <label class="mb-2"><strong> {{ $translate('interaction_types') }}</strong></label>
                            <b-form-select class="form-control" id="input-customer-agent"
                                v-model="orderFilter.interaction_type_id" :options="interactionTypes" text-field="name"
                                value-field="id" required trim>
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_interaction_type')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" cols="12" class="d-flex align-items-center mt-3">
                            <b-col md="8" cols="12" class="me-2 dd">
                                <label class="mb-2"><strong> {{ $translate('review') }}</strong></label>
                                <b-form-select class="form-control" id="input-progress-status"
                                    v-model="orderFilter.checkoff_type_id" value-field="id" text-field="name"
                                    :options="checkoffTypes">
                                    <template #first>
                                        <b-form-select-option :value="null">{{ $translate('select_progress_status')
                                        }}</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="4" cols="12" class="mt-4">
                                <div class="d-flex">
                                    <div class="form-check me-2" v-for="(item, idx) in completedValues"
                                        v-bind:key="'review-radio' + idx">
                                        <!-- :disabled="!orderFilter.checkoff_type_id" -->
                                        <label class="form-check-label lh-1">
                                            <input type="radio" class="form-check-input" name="radio-checkoff_completed"
                                                v-model="orderFilter.checkoff_completed" :value="item.value" />
                                            {{ item.text }}
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                </div>
                            </b-col>
                        </b-col>
                        <b-col :md="statusCompleted ? 3 : 6" cols="12" class="lh-base mt-3">
                            <label class="me-2"><strong>{{ $translate('updates') }}</strong></label>
                            <div class="d-flex flex-nowrap flex-lg-wrap mt-1">
                                <div class="form-check me-2" v-for="(item, idx) in changedValues"
                                    v-bind:key="'update-radio' + idx">
                                    <label class="form-check-label lh-1">
                                        <input type="radio" class="form-check-input" name="radio-updated"
                                            v-model="orderFilter.is_updated" :value="item.value" />
                                        {{ item.text }}
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </b-col>
                        <b-col v-if="statusCompleted" md="3" cols="12" class="lh-base mt-3">
                            <label class="me-2"><strong>{{ $translate('completed') }}</strong></label>
                            <div class="d-flex mt-1">
                                <div class="form-check me-2" v-for="(item, idx) in completedActivityValues"
                                    v-bind:key="'update-radio' + idx">
                                    <label class="form-check-label lh-1">
                                        <input type="radio" class="form-check-input" name="radio-updated"
                                            v-model="orderFilter.completed" :value="item.value" />
                                        {{ item.text }}
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </form>
            </b-card-body>
        </b-card>
    </b-col>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-queryfilters',
    mixins: [permissionsMixins],

    props: [
        'orderTypes',
        'checkoffTypes',
        'officers',
        'customerAgents',
        'interactionTypes',
        'roles',
        'progressStatuses',
        'categories',
        'value',
        'disabledOfficers',
    ],
    data() {
        return {}
    },
    computed: {
        status() {
            return [
                { id: 1, name: this.$translate('completed') },
                { id: 2, name: this.$translate('processing') },
                { id: 3, name: this.$translate('pending') },
            ]
        },
        allowToSeeOtherOfficers(){
            return !!this.user_permissions.includes('view.activity.assigned.to.others');
        },
        orderFilter: {
            // getter
            get() {
                console.log('...........', this.value)
                return this.value
            },
            // setter
            set(val) {
                if (!val.checkoff_type_id) {
                    val.checkoff_completed = null
                }
                val.completion_date_from
                this.$emit('input', val)
            },
        },
        completedValues() {
            return [
                { value: null, text: this.$translate('any') },
                { value: 1, text: this.$translate('yes') },
                { value: 2, text: this.$translate('no') },
            ]
        },
        completedActivityValues() {
            return [
                { value: 1, text: this.$translate('yes') },
                { value: 2, text: this.$translate('no') },
            ]
        },
        changedValues() {
            return [
                { value: null, text: this.$translate('all') },
                { value: 1, text: this.$translate('changed') },
                { value: 2, text: this.$translate('unchanged') },
            ]
        },
        statusCompleted() {
            return this.orderFilter.status == 1
        }
    },
    mounted() { },
    methods: {},
}
</script>
